import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D6A5CF49-38A9-4911-ACAC-FF9A09BBEC76
 * name slash-forward-box
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slash-forward-box.svg
 * tags
 * - Math 
 */
export const SlashForwardBoxIcon = createSvgIcon(<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.3 19H7L14.7 5H17L9.3 19Z" /></>, 'SlashForwardBoxIcon');
export default SlashForwardBoxIcon